
import { ISortBoxModel } from "../../lib/sortbox/ISortBoxModel";
import { ISortBoxItemModel } from "../../lib/SortBoxItem/ISortBoxItemModel";
import { ApplicationStateTypes } from "../../lib/store/types/ApplicationStateTypes";
import { LoginStateTypes } from "../../lib/store/types/LoginStateTypes";

export enum ActionStates  {
    LOAD_BOX= 0,
    COMPLETE_BOX=  1,
  };

export interface IAutoStoreControlAppState {
    action: ActionStates,
    scanDisabled: boolean,
    boxReview : null|IAutoStoreBoxReview,
    missingSortBoxItem: ISortBoxItemModel | null,
    showMissingAmountDialogSortBoxItem: ISortBoxItemModel | null,
    warningMessage: string | null,
    showVerifyIPackBoxBarcodeModal: boolean,
    iPackBoxBarcode : string | null,
    isEmptyTransitBox: boolean,
    weightError:string,
    restartDeliveryModalOpen: boolean,
    wrongRXBagScanned:boolean,
    boxReplacementNeeded: boolean,
    boxReplacementError:string | null
}

export interface IAutoStoreBoxReview{
        sortBoxModel: ISortBoxModel,
        orderWarnings: string[],
        orderShippingMethod: number,
        orderLatestShippingTime: string,
        destinationTransitShelf: string | null,
        boxIsFinalized:boolean,
        isTransitBox:boolean,
        isAutoStoreFinished : boolean,
        isAframeFinalized : boolean,
        isAframeBox:boolean
}

export interface IAutoStoreFetchBoxReviewRequest{
  barcode: string,
  forceTransit:boolean
}


export interface IAutoStoreRestartBoxDeliveryRequest{
  barcode: string,
  invoiceNumber:number,
}

export type DefaultDispatchType = {
  type: string,
};



export type DispatchType = (arg: ApplicationStateTypes | LoginStateTypes | DefaultDispatchType ) => void;